/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable prefer-template */
/* eslint-disable no-plusplus */

export default function renderBackgroundDots (canvasId) {
    const canvas = document.getElementById(canvasId);

    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    
    const ctx = canvas.getContext('2d');
    
    window.addEventListener('resize', () => {
        canvas.width = canvas.offsetWidth;
        canvas.height = canvas.offsetHeight;
    });

    
    function Point() {
        const p = this;
        const r = 5;
        let numDots = 40;
        
        
        // moves point to set location on the grid and 
        // resets its progress
        this.init = function(index, row) {
            // Randomize initial progress so only a few dots animate in viewport at the same time
            let initialProgress = (-0.6 * Math.random());

            // This is to make sure at least a few dots are animating in the first 10 seconds
            // just in case all are randomly taking a long time to animate in
            // if( row !== 0 && (index * row) % 23 === 0) {
            //     initialProgress = (-30 * Math.random());
            // }

            let heightBetween = 40;
            let xStart = 20;
            if(canvas.width < 600) {
                numDots = 20;
                heightBetween = 30;
                xStart = 10;
            } else {
                numDots = 40;
            }

            p.x = ((index / numDots) * canvas.width) + xStart;
            p.y = (row * heightBetween) + 10;

            p.progress = initialProgress;
        }
        
        this.draw = function() {
            ctx.fillStyle = 'rgba(255,255,255,0.2)';
            ctx.beginPath();

            // Base radius of a dot
            let radius = 1;

            // If dot is in the first half of its animation, increase radius to max size
            // If dot is in the second half of its animation, decrease radius from the max size
            if(p.progress > 0 && p.progress < 0.5) {
                radius += (p.progress * r);
            } else if(p.progress >= 0.5) {
                radius += ((0.5 - (p.progress - 0.5)) * r);
            }
            ctx.arc(p.x, p.y, Math.abs(radius), 0, 2*Math.PI);
            ctx.fill();
            
        };
        this.render = function(index, row) {
            if(p.progress < 0.5) {
                p.progress += 0.005;
            } else {
                p.progress += 0.008;
            }
            p.draw();
            if(p.progress >= 1) p.init(index, row);
        }
    }
    
    // number of dots per row
    let n = 40;
    // current amount of rows
    let r = 0;
    
    let dots = [];
    while(r * 20 < canvas.height) {
        for(let i = 0; i < n; i++) {
            dots[i + (r * n)] = new Point();
            dots[i + (r * n)].init(i, r);
        }
        r++;
    }
    
    function loop() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if(canvas.width < 600 && n !== 20) {
            n = 20;
            r = 0;
            dots = [];
            while(r * 20 < canvas.height) {
                for(let i = 0; i < n; i++) {
                    dots[i + (r * n)] = new Point();
                    dots[i + (r * n)].init(i, r);
                }
                r++;
            }
        } else if(canvas.width >= 600 && n !== 40) {
            n = 40;
            r = 0;
            dots = [];
            while(r * 20 < canvas.height) {
                for(let i = 0; i < n; i++) {
                    dots[i + (r * n)] = new Point();
                    dots[i + (r * n)].init(i, r);
                }
                r++;
            }
        }

        r = 0;
        while(r * 20 < canvas.height) {
            for(let i = 0; i < n; i++) {
                if(dots[i + (r * n)]) {
                    dots[i + (r * n)].render(i, r);
                }
            }
            r++;
        }
            
        requestAnimationFrame(loop);
    }
    
    loop();
}



// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/BackgroundDots.jsx